import React, {Component} from 'react';
import {observer} from 'mobx-react';
import Form from 'react-jsonschema-form';
import {postData, formatElementsforExport} from '../../utils/Utils';
import intl from 'react-intl-universal';
import Mousetrap from 'mousetrap';
import Button from '../../components/Button/index';

import './Survey.css';
import {debounce} from "underscore";

@observer
class Survey extends Component {
    constructor() {
        super();
        this.submitHandler = this.submitHandler.bind(this);
        this.state = {
            formData: {},
            submitted: false
        };
    }


    exitModal = () => {
        this.props.history.push('/');
    };
    onFocus = (el) => {
        let element = document.getElementById(el);
        if (!element.classList.contains('mousetrap')) {
            element.classList.add('mousetrap');
        }
    };
    componentDidMount = () => {
        Mousetrap.bind(['escape'], this.exitModal);

    };
    componentWillUnmount = () => {
        Mousetrap.unbind(['escape'], this.exitModal);

    };
    submitHandler = () => {
        if (this.state.submitted === true) {
            return;
        }
        this.setState({
            submitted: true
        });
        let data = {
            responseId: this.props.appStore.responseID,
            branchId: this.props.appStore.appConfig.branchId,
            tableName: (this.props.appStore.environment === 'staging') ? "mycampus_elems_test" : 'mycampus_elems',
            mapData: {
                elements: []
            }
        };

        data.mapData.elements = formatElementsforExport(this.props.appStore.elementStore.elements);
        data.demographics = this.state.formData;

        let productionURL = 'https://23tkwzjvr2.execute-api.us-east-1.amazonaws.com/myc_postdata_s3_lambda/MYC-S3-Lambda';
        let stagingURL = 'https://dj3mppbaa4.execute-api.us-east-1.amazonaws.com/myc_postdata_s3_lambda_staging/MYC-S3-Lambda_STAGING';

        postData((this.props.appStore.environment === 'production') ? productionURL : stagingURL, JSON.stringify(data), (response) => {
            console.log(this.props.appStore.environment, response);
            if (response.ok) {
                this.props.history.push('/end');
            } else {
                this.props.history.push('/error');
            }
        });

    };
    formHandler = (form) => {
        this.setState({formData: form.formData});
    };

    ErrorListTemplate = (props) => {
        const {errors} = props;
        return (
            <div>
                {errors.map((error, i) => {
                    return (
                        <li key={i}>
                            {error.message}
                        </li>
                    );
                })}
            </div>
        );
    };

    render() {
        const {appStore} = this.props;
        const log = (type) => console.log.bind(console, type);
        return (
            <div className={(this.props.appStore.isMobile) ? "Survey mobile" : "Survey desktop"}>
                <div className="container">
                    <link rel="stylesheet"
                          href="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0-beta.3/css/bootstrap.min.css"
                          integrity="sha384-Zug+QiDoJOrZ5t4lssLdxGhVrurbmBWopoEl+M6BdEfwnCJZtKxi1KgxUyJq13dy"
                          crossOrigin="anonymous"/>

                    <Button className='closeButton' aria-label="Close button" onClick={this.exitModal}>
                        <i className="fa fa-times" aria-hidden="true"/>
                    </Button>

                    <h1>{this.props.appStore.content.demographics.headline}</h1>
                    <p>{this.props.appStore.content.demographics.description}</p>

                    {!this.state.submitted &&
                    <Form schema={appStore.surveyConfig.schema}
                          uiSchema={appStore.surveyConfig.UISchema}
                          liveValidate={true}
                          formData={this.state.formData}
                          ErrorList={this.ErrorListTemplate}
                          onChange={this.formHandler}
                          onFocus={this.onFocus}
                          onSubmit={this.submitHandler}
                          onError={log("errors")}>
                    </Form>}

                    {this.state.submitted &&
                    <div className="loading_container">
                        <p>{intl.get("Survey.submitting")}</p>
                        <img className="loading_spinner" src="imgs/loading.gif" alt="Loading..."/>
                    </div>
                    }
                </div>

            </div>
        );
    }
}

export default Survey;


// WEBPACK FOOTER //
// ./src/scenes/Survey/index.js